import { Module, MutationTree } from 'vuex';
import qs from 'qs';
import _ from 'lodash';
import { RootStore } from '@/main/store/@types/store.d';

import { ExternalLocalizations, External, Permissions, ExternalCrumb, OpenerOptions } from '../@types/external.d';
import { actions } from './actions';
import { types } from './types';

const mutations: MutationTree<External> = {
	[types.mutations.REPLACE_EXTERNAL_ROUTE](state, payload: string) {
		state.externalRoute = payload;
	},
	[types.mutations.SET_OPENER](state, payload: OpenerOptions) {
		state.opener = payload;
	},
	[types.mutations.INITIALISE_STORE]: (state, payload: {
		resource: ExternalLocalizations,
		tenantHost: string,
		tenant: string,
		src: string,
		api: string,
		externalRoute: string,
	}) => {
		state.resource = payload.resource;
		state.tenantHost = payload.tenantHost;
		state.tenant = payload.tenant;
		state.src = payload.src;
		state.api = payload.api;
		state.externalRoute = payload.externalRoute;
		state.modulesInitialized = true;
	},
	[types.mutations.RESET_EXTERNAL_MODULES]: (state) => {
		state.modulesInitialized = false;
	},
	[types.mutations.SET_EXTERNAL_MODULES_PERMISSIONS]: (state, permissions: Permissions) => {
		state.modulesPermissions = permissions;
	},
	[types.mutations.REPLACE_EXTERNAL_CRUMBS]: (state, crumbs: ExternalCrumb[]) => {
		state.crumbs = crumbs;
	},
};

export const external: Module<External, RootStore> = {
	namespaced: true,
	state: {
		resource: {},
		modulesInitialized: false,
		modulesPermissions: {} as Permissions,
		externalRoute: '',
		tenantHost: '',
		tenant: '',
		src: '',
		api: null,
		crumbs: [],
		opener: {
			opener: null,
			host: null,
			prop: null,
			action: null,
			extraParams: {},
		},
	},
	actions,
	getters: {
		[types.getters.EXTERNAL_URL]: (state) => {
			const queryParams = qs.parse(window.location.search, {
				ignoreQueryPrefix: true,
			});

			// divide path and query
			const normalizedQueryParams = _.omit(queryParams, 'd');
			const queryString = qs.stringify(normalizedQueryParams, { encode: false, skipNulls: true });

			// append query correctly to path with tenantHost and tenant params
			const queryAppended = queryString ? `${queryString}&d=${state.tenant}&tenantHost=${state.tenantHost}`
				: `d=${state.tenant}&tenantHost=${state.tenantHost}`;

			return `${state.src}${state.externalRoute}?${queryAppended}`;
		},
	},
	mutations,
};
